import React from 'react';
import { ErrorBoundaryTW } from '../../../../../../tailwindComponents/errorBoundary/ErrorBoundaryTW';
import { ErrorMessageTW } from '../../../../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { ComboBoxTW } from '../../../../../../tailwindComponents/selectTW/combobox/ComboBoxTW';
import { SpinnerSize } from '../../../../../../ui-toolkit';
import { useSetCloser } from './hooks/useSetCloser';
import { useGetCloser } from './hooks/useGetCloser';
import { LoadingSpinnerTW } from '../../../../../../tailwindComponents/loadingSpinnerTW/LoadingSpinnerTW';

export const SetCloserForm: React.FC<{ onSuccess?: () => void }> = ({ onSuccess }) => {
  const { assignedCloser } = useGetCloser();

  if (!assignedCloser) {
    return <CloserSelect onSuccess={onSuccess} />;
  }

  return (
    <ComboBoxTW
      options={[]}
      value={{ label: `${assignedCloser.firstName} ${assignedCloser.lastName}`, value: null }}
      disabled
      isRequired
      labelText={'Closer'}
    />
  );
};

const CloserSelect: React.FC<{ onSuccess?: () => void }> = ({ onSuccess }) => {
  const { combinedSuccess, combinedIsLoading, combinedError, options, onSubmit } = useSetCloser(onSuccess);

  return (
    <ErrorBoundaryTW>
      <LoadingSpinnerTW isLoading={combinedIsLoading} spinnerSize={SpinnerSize.tiny}>
        <ErrorMessageTW rtkError={combinedError} />
        <form name={'Set Closer'} id={'set-closer-form'}>
          <ComboBoxTW
            options={options}
            onChange={onSubmit}
            isRequired
            labelText={'Closer'}
            placeholder={'Select a closer'}
            disabled={combinedSuccess}
          />
        </form>
      </LoadingSpinnerTW>
    </ErrorBoundaryTW>
  );
};
